import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, orderPickupButtonMobile } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/4uxruBhi1YtUCdn3g8Gz/locations/m6taHLIBVfLotYx1Ct4t`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="80%"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/4uxruBhi1YtUCdn3g8Gz/locations/m6taHLIBVfLotYx1Ct4t`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="25vw"
                  maxWidth="300px"
                  minWidth="280px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
